/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SpendRuleTargetCondition = {
  /**
   * Member attribute name.
   */
  attribute: string;
  /**
   * Comparison operator: equals, not_equals, starts_with, ends_with, contains, matches, or includes.
   */
  operator: string;
  /**
   * Comparison value.
   */
  value: string;
};

/** @internal */
export const SpendRuleTargetCondition$inboundSchema: z.ZodMiniType<
  SpendRuleTargetCondition,
  unknown
> = z.object({
  attribute: z.string(),
  operator: z.string(),
  value: z.string(),
});
/** @internal */
export type SpendRuleTargetCondition$Outbound = {
  attribute: string;
  operator: string;
  value: string;
};

/** @internal */
export const SpendRuleTargetCondition$outboundSchema: z.ZodMiniType<
  SpendRuleTargetCondition$Outbound,
  SpendRuleTargetCondition
> = z.object({
  attribute: z.string(),
  operator: z.string(),
  value: z.string(),
});

export function spendRuleTargetConditionToJSON(
  spendRuleTargetCondition: SpendRuleTargetCondition,
): string {
  return JSON.stringify(
    SpendRuleTargetCondition$outboundSchema.parse(spendRuleTargetCondition),
  );
}
export function spendRuleTargetConditionFromJSON(
  jsonString: string,
): SafeParseResult<SpendRuleTargetCondition, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SpendRuleTargetCondition$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SpendRuleTargetCondition' from JSON`,
  );
}
